"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRemainingConventionalIncomeTypesData = exports.remainingConventionalIncomeTypesFormRules = exports.remainingConventionalIncomeTypesSchema = void 0;
const converters_1 = require("../../converters");
const income_1 = require("./income");
exports.remainingConventionalIncomeTypesSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
    },
    messages: {
        ...income_1.incomeSchema.messages,
    },
};
// 🚀 Pre-computed validations for performance
exports.remainingConventionalIncomeTypesFormRules = (0, converters_1.toReactHookForm)(exports.remainingConventionalIncomeTypesSchema, income_1.incomeFieldMapping);
exports.validateRemainingConventionalIncomeTypesData = (0, converters_1.createValidator)(exports.remainingConventionalIncomeTypesSchema);
